import { MemberTypeListPage } from '@/features/member-type/pages/MemberTypeListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/member-type/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["member_type.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: MemberTypeListPage,
})
